import { Box, useTheme } from '@mui/material';
import { useMediaQuery } from '@mui/material';
import { Link, styled, Typography } from '@mui/material';
import React from 'react';
import { Link as LinkRouter } from 'react-router-dom';
import { AuthLayoutFooterProps } from '../../../../../fresh-watch/components/auth/AuthLayout/AuthLayoutFooter';
import { getPolyglot } from '../../../../../../i18n';
import { LinkStyled } from '../../../../../../components/auth/AuthLayout/AuthLayoutFooter/AuthLayoutFooter';
import { ALLOWED_URLS } from '../../../../../../components/App/footer/LinksFooter';

export function FFAuthLayoutFooter(props: AuthLayoutFooterProps) {
  const theme = useTheme();
  const polyglot = getPolyglot();
  const { urlStatus = 'https://stats.uptimerobot.com/xxuCT7SMXT' } = props;

  const predefinedLinks = {
    [ALLOWED_URLS.PRIVACY_POLICY]: {
      label: polyglot.t('footer.privacy_policy'),
      to: 'https://www.foursfringand.com/fr/privacy',
      external: true,
    },
    [ALLOWED_URLS.IMPRESSUM]: {
      label: polyglot.t('footer.impressum'),
      to: 'https://www.foursfringand.com/fr/mentions-legales/',
      external: true,
    },
    [ALLOWED_URLS.TERMS_AND_CONDITIONS]: {
      label: polyglot.t('footer.terms_and_conditions'),
      to: 'https://www.foursfringand.com/en/terms-and-conditions/',
      external: true,
    },
    [ALLOWED_URLS.COOKIE_POLICY]: {
      label: polyglot.t('footer.cookie_policy'),
      to: 'https://www.foursfringand.com/fr/politique-confidentialite/',
      external: true,
    },
    [ALLOWED_URLS.ABOUT_US]: {
      label: polyglot.t('footer.about_us'),
      to: 'https://www.foursfringand.com/en/lentreprise-fringand/',
      external: true,
    },
  };
  return (
    <Box
      display={'flex'}
      flexWrap={'wrap'}
      sx={{
        '& .MuiTypography-root': {
          fontSize: '0.8rem',
        },
      }}
    >
      {Object.keys(predefinedLinks).map((key) => {
        const link = predefinedLinks[key as keyof typeof predefinedLinks];
        return (
          <React.Fragment key={key}>
            <LinkStyled
              to={link.to}
              component={link.external ? 'a' : LinkRouter}
              href={link.external ? link.to : link.to}
              target={link.external ? '_blank' : '_self'}
            >
              {link.label}
            </LinkStyled>
            <Typography color={theme.palette.primary.main} px={0.2}>
              {'·'}
            </Typography>
          </React.Fragment>
        );
      })}
      <LinkStyled px={0.2} href={urlStatus} target={'_blank'}>
        {polyglot.t('footer.status')}
      </LinkStyled>
    </Box>
  );
}
